import { createSelector } from 'reselect';

const selectPartners = (state: any) => state.partners;

export const selectPartnersCurrentItem = createSelector([selectPartners], (partners) => partners.current);

export const selectPartnersListItems = createSelector([selectPartners], (partners) => partners.list);


export const selectPartnersItemById = (itemId: any) =>
    createSelector(selectPartnersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPartnersQueryItems = createSelector([selectPartners], (partners) => partners.query);

export const selectPartnersCreatedItem = createSelector([selectPartners], (partners) => partners.create);

export const selectPartnersUpdatedItem = createSelector([selectPartners], (partners) => partners.update);

export const selectPartnersReadItem = createSelector([selectPartners], (partners) => partners.read);

export const selectPartnersDeletedItem = createSelector([selectPartners], (partners) => partners.delete);

export const selectPartnersSearchedItems = createSelector([selectPartners], (partners) => partners.search);

export const selectPartnersItemsCount = createSelector([selectPartners], (partners) => partners.count);

export const selectPartnersItemsFilter = createSelector([selectPartners], (partners) => partners.filter);